jQuery(function ($) {
 
    //Home Slider
    $('.homeSlider').owlCarousel({
        loop: false,
        margin: 0,
        dots: true,
        nav: false,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1
            },
            420: {
                items: 1
            },
            600: {
                items: 1
            }
        }
    });
    //    < ------------------------------------------------------>
    //Share Slider 
    //Home Slider
    $('.shareSlider').owlCarousel({
        loop: false,
        margin: 0,
        dots: true,
        nav: false,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1
            },
            420: {
                items: 1
            },
            600: {
                items: 1
            }
        }
    });
    // < ----------------------------------------------------------- >
    $('.collectionSlider').owlCarousel({
        loop: false,
        margin: 20,
        dots: false,
        nav: true,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsiveClass: true,
        //navText: ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
        navText: ["<img src='https://cdn.shopify.com/s/files/1/0806/9339/5774/t/4/assets/arrow-circle-left.svg?v=1698690155'>","<img src='https://cdn.shopify.com/s/files/1/0806/9339/5774/t/4/assets/arrow-circle-right.svg?v=1698690168'>"],
        responsive: {
            0: {
                items: 2,
                dots: true,
                nav: false
            },
            375: {
                items: 3,
                dots: true,
                nav: false
            },
            575: {
                items: 3,
                dots: true,
                nav: false
            },
            960: {
                items: 6
            },
            1200: {
                items: 7
            }
        }
    })
    //    < ------------------------------------------------------>
    //Blog Slider
      $('.blogSlider').owlCarousel({
          loop: true,
          margin: 20,
          dots: false,
          nav: true,
          autoplay: true,
          autoplayHoverPause: true,
          autoplayTimeout:8000,
          responsiveClass: true,
          //navText: ['<span class="fa fa-angle-left"></span>','<span class="fa fa-angle-right"></span>'],
          navText: ["<img src='https://cdn.shopify.com/s/files/1/0806/9339/5774/t/4/assets/arrow-circle-left.svg?v=1698690155'>","<img src='https://cdn.shopify.com/s/files/1/0806/9339/5774/t/4/assets/arrow-circle-right.svg?v=1698690168'>"],
          items: 3,
          responsive: {
              0: {
                  items: 1,
                  margin: 0
              },
              375: {
                  items: 1,
                  margin: 0
              },
              960: {
                items: 3,
                margin: 20
              }
          }
      })
      //    < ------------------------------------------------------>
   //Insperation subpage Slider
    $('.inspSubSlider').owlCarousel({
        loop: false,
        margin: 0,
        dots: true,
        nav: false,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1
            },
            420: {
                items: 1
            },
            600: {
                items: 1
            }
        }
    });
  //    < ------------------------------------------------------>
      //Home Slider
      $('.RelatedProductSlider').owlCarousel({
          loop: false,
          margin: 20,
          dots: false,
          nav: true,
          autoplay: true,
          autoplayTimeout: 4000,
          autoplayHoverPause: true,
          responsiveClass: true,
          //navText: ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
          navText: ["<img src='https://cdn.shopify.com/s/files/1/0806/9339/5774/t/4/assets/arrow-circle-left.svg?v=1698690155'>","<img src='https://cdn.shopify.com/s/files/1/0806/9339/5774/t/4/assets/arrow-circle-right.svg?v=1698690168'>"],
          responsive: {
              0: {
                  items: 1,
                  dots: true,
                  nav: false
              },
              575: {
                  items: 2,
                  dots: true,
                  nav: false
              },
              960: {
                  items: 3
              },
              1200: {
                  items: 4
              }
          }
      })
      //    < ------------------------------------------------------>
      //Blog Slider
      $('.aboutSlider').owlCarousel({
          //stagePadding: 380,
          loop: true,
          margin: 20,
          dots: false,
          nav: true,
          // autoplay: true,
          // autoplayTimeout: 4000,
          // autoplayHoverPause: true,
          responsiveClass: true,
          //navText: ['<span class="fa fa-angle-left"></span>','<span class="fa fa-angle-right"></span>'],
          navText: ["<img src='https://cdn.shopify.com/s/files/1/0806/9339/5774/t/4/assets/arrow-circle-left.svg?v=1698690155'>","<img src='https://cdn.shopify.com/s/files/1/0806/9339/5774/t/4/assets/arrow-circle-right.svg?v=1698690168'>"],
          items: 6,
          responsive: {
              0: {
                  items: 1,
                  margin: 8,
                  //stagePadding: 25
              },
              375: {
                  items: 1,
                  margin: 10,
                  //stagePadding: 30
              },
              480: {
                  items: 2,
                  //margin: 10,
                  //stagePadding: 30
              },
              768: {
                  items: 4,
                  //stagePadding: 40,
              },
              1023: {
                //items: 4,
                //stagePadding: 120,
              },
              1199: {
                //stagePadding: 180,
              },
              1365: {
                //stagePadding: 260,
              },
              1439: {
                //stagePadding: 300,
              },
              1600: {
                //stagePadding: 380,
              }
          }
      });
      var brandSlider = $('.aboutSlider');
      function brandSliderClasses() {
          brandSlider.each(function() {
              var total = $(this).find('.owl-item.active').length;
              $(this).find('.owl-item').removeClass('firstactiveitem');
              $(this).find('.owl-item').removeClass('lastactiveitem');
              $(this).find('.owl-item.active').each(function(index) {
                  if (index === 0) {
                      $(this).addClass('firstactiveitem')
                  }
                  if (index === total - 1 && total > 1) {
                      $(this).addClass('lastactiveitem')
                  }
              })
          })
      }
      brandSliderClasses();
      brandSlider.on('translated.owl.carousel', function(event) {
          brandSliderClasses()
      }); 
      //    < ------------------------------------------------------>
  //iframe

  // collection list
  $('.collection-list-slider.owl-carousel').each(function() {
    let desktopItems = $(this).data('cols');
    let mobileItems = $(this).data('cols-mobile');
    let enableDesktop = $(this).data('enable-desktop');
    let enableMobile = $(this).data('enable-mobile');
    if ((window.innerWidth > 768 && enableDesktop) || (window.innerWidth <= 768 && enableMobile)) {
      var collectionListOwl = $(this).owlCarousel({
        loop: false,
        margin: 20,
        dots: false,
        nav: true,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsiveClass: true,
        navText: ["<img src='https://cdn.shopify.com/s/files/1/0806/9339/5774/t/4/assets/arrow-circle-left.svg?v=1698690155'>","<img src='https://cdn.shopify.com/s/files/1/0806/9339/5774/t/4/assets/arrow-circle-right.svg?v=1698690168'>"],
        responsive: {
          0: {
            items: mobileItems,
            dots: true,
            nav: false
          },
          375: {
            items: mobileItems,
            dots: true,
            nav: false
          },
          575: {
            items: mobileItems,
            dots: true,
            nav: false
          },
          960: {
            items: desktopItems > 3 ? 3 : desktopItems
          },
          1200: {
            items: desktopItems
          }
        }
      });
      if ($(this).find('.owl-nav.disabled').length) {
        $('.collection-list-slider').addClass('no-nav');
        collectionListOwl.trigger('refresh.owl.carousel');
      }
    } else {
      $(this).removeClass('owl-carousel');
      $(this).addClass(`collection-list grid grid--${desktopItems}-col-desktop grid--${mobileItems}-col-tablet-down`);
      $(this).find('.collection-list__item').addClass('grid__item');
    }
  });
});
$(document).ready(function() {
  $(".NeedtoknowBox > .accordion").on("click", function() {
    $(this).parent().toggleClass('active-color');
    $(this).toggleClass("active");
    $(this).next(".accordion-panel").slideToggle(200);
  });
});
//Slide animation for <details> accordions
$(document).ready(function() {
  $(document).on("click", ".collapsible-content .accordion details > summary, .product__accordion details > summary", function(event) {
    var $summary = $(this);
    var $details = $summary.parent();
    var $content = $summary.next(".accordion__content");
    if (!$content.length) return;

    event.preventDefault();
    $content.stop(true, true);

    if ($details.is("[open]")) {
      $details.addClass("is-closing");
      $content.slideUp(200, function() {
        $details.removeAttr("open").removeClass("is-closing");
        $content.css("display", "");
      });
    } else {
      $details.attr("open", "");
      $content.hide().slideDown(200, function() {
        $content.css("display", "");
      });
    }
  });
});
//Product desc Read more
$(document).ready(function() {
  var divHeight = $(".productDesc").height();
  if (divHeight < 65){
    $(".readMore").css("display", "none");
  }
  $('.readMore').click(function(e) {
    var isExpanded =  $('.productDesc').hasClass("expand");

    if (!isExpanded){
      $('.productDesc').addClass("expand");
      $('.readMore').removeClass("down");  
      $('.readMore').addClass("up");
      //$(this).text("Read less");
    } else {
      $('.productDesc').removeClass("expand"); 
      $('.readMore').removeClass("up");  
      $('.readMore').addClass("down");
      //$(this).text("Read more");
    }

  });
});
$(document).ready(function() {
 var cartDrower = document.querySelector('cart-drawer');
// Function to add all products from a collection to the cart using Ajax
function addCollectionProductsToCart(collectionHandle) {
  var productIds = [];
  jQuery.get('/collections/' + collectionHandle + '/products.json', function(data) {
    for (var i = 0; i < data.products.length; i++) {
      var product = data.products[i];
      //let product_object = {quantity: 1,id: product.variants[0].id}
      //console.log(product);
      if(product.variants[0].available){
        productIds.push({
          quantity: 1, 
          id: product.variants[0].id
        }) ; // Assuming you want to add the first variant of each product
      }
    }
  }).done(function() {
       $.ajax({
          url: "/cart/add.js",
          type: "POST",
          data: {
            items:productIds,
            sections : cartDrower.getSectionsToRender().map((section) => section.id),
            sections_url : window.location.pathname,
          },
          dataType: 'json',
          error: function(data) {
                alert(data.responseJSON.message+"\n"
            +"\n" +data.responseJSON.description);
           },
           success: function(data) {
              $.each(data.items, function (key, val) {
                 val['sections'] = data.sections;
                const parsedState = data;
                 if (cartDrower) cartDrower.classList.toggle('is-empty', parsedState.item_count === 0);
                    cartDrower.renderContents(val)
             });
           }
       });
    
  });
}

// Function to get product IDs from a collection
function getCollectionProductIds(collectionHandle) {
  var productIds = [];
  jQuery.get('/collections/' + collectionHandle + '/products.json', function(data) {
  
    for (var i = 0; i < data.products.length; i++) {
      var product = data.products[i];
      //let product_object = {quantity: 1,id: product.variants[0].id}
      //console.log(product);
      productIds.push({
        quantity: 1, 
        id: product.variants[0].id
      }) ; // Assuming you want to add the first variant of each product
    }
      return productIds;
  });
//return productIds;
}

// Bind the function to a button click event
jQuery(document).ready(function() {
  jQuery('.add-collection-to-cart').on('click', function() {
    var collectionHandle = jQuery(this).data('collection-handle');
    addCollectionProductsToCart(collectionHandle);
  });
});
  
  // Add breadcrumb to policies page
  jQuery(document).ready(function() {
    if (document.querySelector('.shopify-policy__title')) {
      let currentPageTitle = document.querySelector('.shopify-policy__title').innerText;
      let policyBreadcrumb = `<div class=" BreadcrumbSec">
          <section class="pt-10 pb-10" style="background-color:#f7f5f2">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <nav class="breadcrumb m-0 p-0" role="navigation" aria-label="breadcrumbs">
                    <a href="/" title="${window.accessibilityStrings.home}">${window.accessibilityStrings.home}</a>
                    <span aria-hidden="true">›</span>
                    <span>${currentPageTitle}</span>
                  </nav>
                </div>
              </div>
            </div>
          </section>
        </div>`;
      // insert before .shopify-policy__title
      jQuery('.shopify-policy__title').before(policyBreadcrumb);
    }
  });
});